import RoleGuard from "@/guards/RoleGuard";
import { Suspense, lazy } from "react";
import { Outlet } from "react-router-dom";
import AuthGuard from "../guards/AuthGuard";
import DashboardLayout from "../layouts/dashboard";
import { PATH_MANAGE_MEETING_SCHEDULER, PATH_MEETING_SCHEDULER } from "./paths";
import { getRelativePath } from "@/utils/paths";

const ManageSchedulersContainer = lazy(() => import("../pages/meeting-scheduler/manage-schedulers/manage.schedulers.container"));

const MeetingSchedulerRoot = (
    <AuthGuard>
        <RoleGuard>
            <DashboardLayout>
                <Suspense>
                    <Outlet />
                </Suspense>
            </DashboardLayout>
        </RoleGuard>
    </AuthGuard>
);


const meetingSchedulerRoutes = [
    {
        path: PATH_MEETING_SCHEDULER,
        element: MeetingSchedulerRoot,
        children: [
            {
                index: true,
                element: <ManageSchedulersContainer />,
            },
            {
                path: getRelativePath(PATH_MEETING_SCHEDULER, PATH_MANAGE_MEETING_SCHEDULER),
                element: <ManageSchedulersContainer />,
            }
        ],
    },
];


export default meetingSchedulerRoutes;
